import React from "react"

const IconAudioMediaButton = props => (
  <svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle opacity="0.7" cx="30.5" cy="30" r="30" fill="#544550"/>
    <path d="M22.3184 18.9986L22.3184 41.0029C22.3184 41.7847 22.9517 42.4243 23.7258 42.4243C23.9721 42.4243 24.2096 42.3621 24.4295 42.2377L43.4295 31.2311C44.1069 30.8402 44.3356 29.9697 43.9485 29.2945C43.8254 29.0724 43.6407 28.8948 43.4295 28.7704L24.4295 17.7638C23.7522 17.3729 22.8901 17.6127 22.5031 18.2879C22.3799 18.51 22.3184 18.7498 22.3184 18.9986Z" fill="#FCFBF9"/>
  </svg>
)

export default IconAudioMediaButton